import { useEffect, useRef, useState } from 'react';
import { Position, PlayerType } from './types';
import { GameEngine } from './GameEngine';
import { DebugOverlay } from './components/DebugOverlay';
import { GameUI } from './components/GameUI';

const TILE_SIZE = 32;
const GRID_COLOR = '#33333333';
const BG_COLOR = '#222222';
const LAND_COLOR = '#4CAF50';
const WATER_COLOR = '#2196F3';
const PLAYER_COLORS: Record<PlayerType, string> = {
  topdown: '#ff0000',
  platformer: '#00ff00',
};

export default function PS2() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const engineRef = useRef<GameEngine>();
  const [positions, setPositions] = useState<Record<PlayerType, Position>>({
    topdown: { x: 0, y: 0 },
    platformer: { x: 0, y: 0 },
  });

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d', { alpha: false, desynchronized: true });
    if (!ctx) return;

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    engineRef.current = new GameEngine(
      ctx,
      {
        tileSize: TILE_SIZE,
        gridColor: GRID_COLOR,
        bgColor: BG_COLOR,
        playerColors: PLAYER_COLORS,
        landColor: LAND_COLOR,
        waterColor: WATER_COLOR,
      },
      setPositions
    );

    engineRef.current.start();

    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    window.addEventListener('resize', handleResize);

    return () => {
      engineRef.current?.stop();
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <GameUI engine={engineRef.current} />
      <DebugOverlay
        engine={engineRef.current}
        positions={positions}
        canvasReady={!!canvasRef.current}
      />
      <canvas
        ref={canvasRef}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: BG_COLOR,
        }}
      />
    </>
  );
}
